export default {
  'add-card': () => import('@icons/4cut-ranking/add-card.svg'),
  'card-crown': () => import('@icons/4cut-ranking/card-crown.svg'),
  'card-crown-gradient': () =>
    import('@icons/4cut-ranking/card-crown-gradient.svg'),
  'card-heart': () => import('@icons/4cut-ranking/card-heart.svg'),
  'card-lock': () => import('@icons/4cut-ranking/card-lock.svg'),
  'crown-1': () => import('@icons/4cut-ranking/crown-1.svg'),
  'crown-2': () => import('@icons/4cut-ranking/crown-2.svg'),
  'game-console': () => import('@icons/4cut-ranking/game-console.svg'),
  'game-guide-arrow': () => import('@icons/4cut-ranking/game-guide-arrow.svg'),
  'gender': () => import('@icons/4cut-ranking/gender.svg'),
  'hall-of-fame-title-left': () =>
    import('@icons/4cut-ranking/hall-of-fame-title-left.svg'),
  'hall-of-fame-title-right': () =>
    import('@icons/4cut-ranking/hall-of-fame-title-right.svg'),
  'pick-cursor': () => import('@icons/4cut-ranking/pick-cursor.svg'),
  'pin': () => import('@icons/4cut-ranking/pin.svg'),
  'ranking-crown-1': () => import('@icons/4cut-ranking/ranking-crown-1.svg'),
  'ranking-crown-2': () => import('@icons/4cut-ranking/ranking-crown-2.svg'),
  'ranking-crown-3': () => import('@icons/4cut-ranking/ranking-crown-3.svg'),
  'report': () => import('@icons/4cut-ranking/report.svg'),
  'user-group': () => import('@icons/4cut-ranking/user-group.svg'),

  // achievement medal icons
  'hall-of-fame-medal-bronze': () =>
    import('@icons/4cut-ranking/achievement/hall-of-fame-medal-bronze.svg'),
  'hall-of-fame-medal-silver': () =>
    import('@icons/4cut-ranking/achievement/hall-of-fame-medal-silver.svg'),
  'hall-of-fame-medal-gold': () =>
    import('@icons/4cut-ranking/achievement/hall-of-fame-medal-gold.svg'),
  'medal-bronze': () =>
    import('@icons/4cut-ranking/achievement/medal-bronze.svg'),
  'medal-silver': () =>
    import('@icons/4cut-ranking/achievement/medal-silver.svg'),
  'medal-gold': () => import('@icons/4cut-ranking/achievement/medal-gold.svg'),
  'medal-platinum': () =>
    import('@icons/4cut-ranking/achievement/medal-platinum.svg'),
  'medal-pick': () => import('@icons/4cut-ranking/achievement/medal-pick.svg'),
  'medal-effect': () =>
    import('@icons/4cut-ranking/achievement/medal-effect.svg'),
};
